<template>
    <c-modal
            v-model="modal"
            size="lg"
            centered
            :tag="false"
            title="Edit Category"
            confirm-label="Save"
            cancel-label="Cancel"
            :progressing="progressing"
            @show="showModal"
    >
        <template>
            <b-container fluid class="px-0">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <b-input-group prepend="Category Name">
                                <b-input  placeholder="Required" class="myFeild" name="Category Name" v-model="model.CategoryDESC" v-validate="'required'"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group>
                            <b-input-group prepend="Category Comments">
                                <b-textarea  placeholder="Optional" class="myFeild" name="Category Comments" v-model="model.CategoryComment"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group>
                            <b-input-group prepend="Displaystation">
                                <b-select
                                    name="Displaystation"
                                    v-validate="'required'"
                                    v-model="model.KDS"
                                    value-field="KDSID"
                                    text-field="KDS"
                                    :options="kds"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group v-if="printStation.length > 1">
                            <b-input-group prepend="Printstation">
                                <b-select name="Printstation"
                                  v-model="model.PrintStation"
                                  value-field="PrinterID"
                                  text-field="PrinterName"
                                  :options="printStation"/>
                            </b-input-group>
                        </b-form-group>
                        <b-input-group v-if="HasTV" prepend="Menu Board TV Name" class="mt-2">
                        <b-form-select
                            class="myFeild"
                            v-model="selectedTV"
                            :options="TVs"
                            placeholder="Select"
                            >
                            <template #first>
                                <b-form-select-option :value="null||''">Select...</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-input-group>
                    <b-input-group v-if="HasTV" prepend="Category Name Spacing - Before (Lines)" class="mt-2 mb-4" style="width: 25rem">
                        <b-input-group-append>
                        <b-button style="border-radius: 100rem;" variant="danger" @click="NumOfLines = Math.max(0, NumOfLines - 1)">
                                <font-awesome-icon icon="minus" class="align-middle"/>
                            </b-button>
                            
                        </b-input-group-append>
                       <b-input
                            type="number"
                            class="myFeild text-center"
                            v-model="NumOfLines" 
                            placeholder="Optional"
                            min="0"
                            :step="1"
                            @input="NumOfLines = Math.max(0, NumOfLines)"
                           
                        />
                        <b-input-group-append>
                        
                            <b-button style="border-radius: 100rem;"  variant="danger" @click="NumOfLines++">
                                <font-awesome-icon icon="plus" class="align-middle"/>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <b-form-group v-if="loyaltyPermission">
                        <b-input-group prepend="Loyalty Reward" class="d-flex flex-nowrap">
                            <Multiselect
                                class="miniMulti"
                                v-model="selectedLoyaltyRewards"
                                isMultiPle
                                :options="loyaltyRewards"
                                name="loyaltyReward"
                                placeHolder="Select Reward..."
                            >
                                <template v-slot:tag="{ option, remove }">
                                    <span :style="{backgroundColor: option.Status === 'active' ? '#FFC107' : '#c8ced3', borderRadius:'12px', padding:'2px 10px', marginRight:'5px', marginBottom:'5px', display:'inline-flex', alignItems:'center'}">
                                        {{ option.name }}
                                        <span class="ml-2 cursor-pointer" @mousedown.prevent="remove(option)"><font-awesome-icon icon="times"/></span>
                                    </span>
                                </template>
                            </Multiselect>
                        </b-input-group>
                    </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <div>Category Order</div>
                    </b-col>
                    <b-col cols="10" md="7">
                        <b-list-group-item style="cursor:pointer;" v-for="item in cats" :active="item.CategoryID === category.CategoryID">
                            {{item.CategoryDESC}}
                        </b-list-group-item>
                    </b-col>
                    <b-col cols="2" class="flex-grow-1">
                        <div class="d-flex flex-column">
                            <b-btn class="mb-4 py-2 py-md-4" size="lg" @click="up">
                                <font-awesome-icon icon="caret-up" class="align-middle"/>
                            </b-btn>
                            <b-btn @click="down" class="py-2 py-md-4" size="lg">
                                <font-awesome-icon icon="caret-down" class="align-middle"/>
                            </b-btn>
                        </div>
                    </b-col>
                </b-row>
                <delete-confirmation
                        :tag="false"
                        v-model="deleteModal"
                        :category="category"
                        :progressing="progressing"
                        @refresh="deleteCategory"/>
            </b-container>
        </template>
        <template #actions>
            <b-row class="flex-grow-1">
                <b-col cols="4">
                    <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="submit">
                        Save
                        <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                    </b-btn>
                </b-col>

                <b-col cols="4">
                    <b-btn variant="danger" block class="text-nowrap" :disabled="progressing" @click="deleteConfirmation">
                        Delete Menu Category
                    </b-btn>
                </b-col>

                <b-col cols="4">
                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
                        Cancel
                    </b-btn>
                </b-col>
            </b-row>
        </template>
    </c-modal>
</template>

<script>
    import CModal from "../../../shared/Cmodal";
    import DeleteConfirmation from "./DeleteConfirmation";
    import Multiselect from '@/components/shared/multiselect'
    export default {
        name: "editCategory",
        components: {
            DeleteConfirmation,
            CModal,
            Multiselect,
            draggable: () => import('vuedraggable')
        },
        props: {
            value: {required: true, type: Boolean, default: false},
            category: {required: true, type: Object},
            currentMenuType: {
                required: false,
            },
            edibleType: {
                required: true,
                type: String
            },
            categories: {
                required: true
            }
        },
        data () {
            return {
                progressing: false,
                model: {
                    FoodCategoryDESC: '',
                    CategoryComment: '',
                    Printstation: 0,
                    KDS: '',
                    SortOrder: [1],
                },
                kds: [],
                printStation: [],
                cats: [],
                deleteModal: false,
                selectedTV:"",
                TVs:[],
                TVrereferences:[],
                NumOfLines:0,
                HasTV:localStorage.getItem("hasMenuboard") === "true",
                loyaltyPermission: false,
                loyaltyRewards: [],
                loyaltyRewardsFull: [],
                selectedLoyaltyRewards: [],
                initialLoyaltyRewardIds: []
            }
        },
      
        computed: {
            modal: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            },
           
            
        },
        methods: {
            showModal () {
                this.HasTV = localStorage.getItem("hasMenuboard") === "true"
                this.cats = this.categories.map(item => ({...item}))
                this.cats.forEach((item, index) => {
                    this.$set(item, 'sortOrder', index)
                })
                this.model = this.category
                Promise.all([
                    this.getKds(),
                    this.getPrintStation(),
                    this.getRestaurantTVs()
                ]).then(res => {
                    this.kds = res[0]
                    this.printStation = [{PrinterName: 'None', PrinterID: 0}, ...res[1]].filter(i => i.PrintTaskID !== 2)
                })
                this.getLoyaltySettings()
            },
            getLoyaltySettings(){
                const model = {RestaurantID: Number(this.$store.state.selectedRestaurantId)}
                return this.$api.loyaltyAdmin.GetSettings(model).then(res => {
                    if(res.success){
                        this.loyaltyPermission = !!res.results.LoyaltyPermission
                        this.loyaltyRewardsFull = res.results.Rewards || []
                        this.loyaltyRewards = this.loyaltyRewardsFull.map(item => ({name: item.Name, value: item.RewardID, Status: item.Status}))
                        this.initialLoyaltyRewardIds = this.loyaltyRewardsFull
                            .filter(reward => {
                                const scope = Array.isArray(reward.Scope) ? reward.Scope : []
                                return scope.some(s => s.ScopeKind === 'category' && Number(s.RefID) === Number(this.category.CategoryID))
                            })
                            .map(reward => reward.RewardID)
                        this.selectedLoyaltyRewards = this.loyaltyRewards.filter(reward => this.initialLoyaltyRewardIds.includes(reward.value))
                    }
                })
            },
            syncLoyaltyRewards(refId, itemCommodity, finalIds, initialIds) {
                const scopeKind = itemCommodity ? 'item' : 'category'
                const toAdd = finalIds.filter(id => !initialIds.includes(id))
                const toRemove = initialIds.filter(id => !finalIds.includes(id))
                const jobs = [...toAdd.map(id => ({id, add: true})), ...toRemove.map(id => ({id, add: false}))]
                return Promise.all(jobs.map(({id, add}) => {
                    const reward = this.loyaltyRewardsFull.find(r => r.RewardID === id)
                    if (!reward) return Promise.resolve()
                    let scope = Array.isArray(reward.Scope) ? [...reward.Scope] : []
                    const matches = s => s.ScopeKind === scopeKind && Number(s.RefID) === Number(refId) && (!itemCommodity || String(s.ItemCommodity).toLowerCase() === String(itemCommodity).toLowerCase())
                    if (add) {
                        if (!scope.some(matches)) {
                            const entry = {ScopeKind: scopeKind, RefID: refId}
                            if (itemCommodity) entry.ItemCommodity = itemCommodity
                            scope.push(entry)
                        }
                    } else {
                        scope = scope.filter(s => !matches(s))
                    }
                    return this.$api.loyaltyAdmin.SaveReward({
                        RestaurantID: Number(this.$store.state.selectedRestaurantId),
                        RewardID: reward.RewardID,
                        Name: reward.Name,
                        PointsThreshold: reward.PointsThreshold,
                        RewardType: reward.RewardType,
                        Value: reward.Value,
                        Scope: scope
                    })
                }))
            },
            getRestaurantTVs(){
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TVid:-1
                }
                return this.$api.getRestaurant.GetRestaurantMenuboardTVs(object).then(res=>{
                    if(res.success){
                        this.TVs = res.menuBoards.map(tv => tv.TVname)
                        this.TVrereferences = res.menuBoards
                        this.selectedTV = ""
                        this.NumOfLines = this.category.CategoryPreSpacing

                    }
                    
                })

            },
            getPrintStation () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
                    if (res.success) {
                        return res.results.RestaurantPrinter
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            getKds () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
                    if (res.success) {
                        return res.results.RestaurantKDS
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {

                })
            },
            submit () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        const model = {...this.model}
                        const findIndex = this.cats.findIndex(item => item.CategoryID === this.category.CategoryID)
                        model.MenuTypeID = this.currentMenuType.MenuTypeID
                        model.RestaurantID = this.$store.state.selectedRestaurantId
                        model.EdibleType = this.edibleType
                        model.KDS = +model.KDS
                        model.Printstation = model.PrintStation
                        model.SortOrder = this.cats.map(item => item.CategoryID)
                        model.CategoryPreSpacing = this.NumOfLines
                        this.progressing = true
                        return this.$api.category.update(model, this.category.CategoryID).then(() => {
                            const rewardIds = this.selectedLoyaltyRewards.map(item => item.value)
                            return this.syncLoyaltyRewards(this.category.CategoryID, null, rewardIds, this.initialLoyaltyRewardIds).finally(() => {
                                if(this.selectedTV != "" && this.selectedTV != null){
                                    let foundTV = this.TVrereferences.find(tv => tv.TVname === this.selectedTV)
                                    let model2 = {
                                        RestaurantID: this.$store.state.selectedRestaurantId,
                                        EdibleType: this.edibleType,
                                        ShowOnTV: foundTV.TVid
                                    }
                                    return this.$api.category.UpdateMenuboardTVByCategory(model2,this.category.CategoryID).then(()=>{
                                        this.progressing = false
                                    this.modal = false
                                    this.$emit('refresh', this.currentMenuType)
                                    this.selectedTV = ""
                                    })
                                }else{
                                    this.progressing = false
                                    this.modal = false
                                    this.selectedTV = ""
                                    this.$emit('refresh', this.currentMenuType)
                                }
                            })
                        }).catch(() => {
                            this.progressing = false
                            this.$showError('Error on update category')
                        })
                    }
                })
            },
            deleteConfirmation () {
                this.deleteModal = true
            },
            deleteCategory () {
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    EdibleType: this.edibleType
                }
                this.progressing = true
                return this.$api.category.delete(model, this.category.CategoryID, true).then(res => {
                    this.progressing = false
                    this.modal = false
                    this.deleteModal = false
                    this.selectedTV = ""

                    this.$emit('refresh', this.currentMenuType)
                }).catch(() => {
                    this.progressing = false
                })
            },
            getSortableOptions() {
                return {
                    animation: 200
                }
            },
            down () {
                let fromIndex = this.cats.findIndex(item => item.CategoryID === this.category.CategoryID)
                if (fromIndex !== this.cats.length - 1) {
                    const toIndex = fromIndex++
                    const element = this.cats.splice(fromIndex, 1)[0]
                    this.cats.splice(toIndex, 0, element)
                }
            },
            up () {
                let fromIndex = this.cats.findIndex(item => item.CategoryID === this.category.CategoryID)
                if (fromIndex !== 0) {
                    const toIndex = fromIndex--
                    const element = this.cats.splice(fromIndex, 1)[0]
                    this.cats.splice(toIndex, 0, element)
                }
            }
        }
    }
</script>

<style scoped>

</style>
